require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./collapse"), require("./flexlayout"), require("./label"), require("./list"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./collapse", "./flexlayout", "./label", "./list", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./collapse"), require("./flexlayout"), require("./label"), require("./list"), require("./utils")) : factory(root["./collapse"], root["./flexlayout"], root["./label"], root["./list"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__48477__, __WEBPACK_EXTERNAL_MODULE__77765__, __WEBPACK_EXTERNAL_MODULE__37394__, __WEBPACK_EXTERNAL_MODULE__70309__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[3220],{

/***/ 10046:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _reactMeasure = _interopRequireDefault(__webpack_require__(9597));
var _utils = __webpack_require__(78815);
var _collapse = _interopRequireDefault(__webpack_require__(48477));
var _list = _interopRequireWildcard(__webpack_require__(70309));
var _flexlayout = __webpack_require__(77765);
var _label = _interopRequireDefault(__webpack_require__(37394));
var _listDropdownHelperFunctions = _interopRequireDefault(__webpack_require__(93757));
var _ListDropdown = _interopRequireDefault(__webpack_require__(9034));
var _Label = _interopRequireDefault(__webpack_require__(75497));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const dropdownClassName = _ListDropdown.default.dropdownClassName.replace(/"/g, '');
const labelClassName = (0, _utils.classnames)(_Label.default.labelClassName.replace(/"/g, ''));
let refListPointer = null;

// Utils
const {
  cssSize
} = _utils.cssUtils;
const {
  IE11,
  getTransformedParentElement
} = _utils.domUtils;
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize
} = _utils.propsUtils;

/* eslint no-underscore-dangle: 'off' */

class ListDropdown extends _react.Component {
  constructor(_props) {
    super(_props);
    (0, _defineProperty2.default)(this, "scrollHandler", e => {
      const {
        onScrollClose
      } = this.props;
      if (this._list && this._list._node !== e.target && e.target.contains(this._list._node)) {
        this.setState({
          scrolled: true
        }, () => {
          onScrollClose && onScrollClose();
          this.setState({
            scrolled: false
          });
        });
      }
    });
    (0, _defineProperty2.default)(this, "_onMenuWidthChange", dimensions => {
      const {
        customWidth,
        open
      } = this.props;
      if (!customWidth && this._menuNode && open) {
        const {
          menuStyle
        } = this.state;
        if (menuStyle) {
          if (dimensions.width > menuStyle.minWidth) {
            this.setState({
              menuStyle: {
                ...menuStyle,
                minWidth: dimensions.width
              }
            });
          }
        }
      }
    });
    (0, _defineProperty2.default)(this, "_menuItemRenderer", (i, props) => {
      const {
        options,
        grouped,
        listItemContentRenderer
      } = this.props;
      let groupName;
      if (grouped && this.currentGroup !== options[i].group) {
        groupName = /*#__PURE__*/_react.default.createElement(_label.default, {
          className: `${dropdownClassName}__groupLabel`,
          label: options[i].group,
          type: "caption"
        });
      }
      this.currentGroup = i !== options.length - 1 ? options[i].group : null;
      const {
        icon,
        onIconClick,
        ...others
      } = options[i];

      // NOTE: This might be changed if the structure of grouped select options are changed
      return /*#__PURE__*/_react.default.createElement("div", {
        key: i
      }, groupName, /*#__PURE__*/_react.default.createElement(_list.ListItem, (0, _extends2.default)({
        "data-tid": `ba-common-list-dropdown__listItem-${i}`
      }, props, sanitize(others, null, 'label', 'group', 'value', 'title'), {
        icon: icon,
        onIconClick: onIconClick,
        className: `${dropdownClassName}__menuItem`,
        id: this._optionId(i)
      }), listItemContentRenderer(props, this.props)));
    });
    (0, _defineProperty2.default)(this, "_onActiveChange", _ref => {
      let {
        index
      } = _ref;
      const {
        onActiveChange
      } = this.props;
      this.setState({
        focusIndex: index
      });
      onActiveChange && onActiveChange(index);
    });
    (0, _defineProperty2.default)(this, "_onSelectionChange", _ref2 => {
      let {
        index
      } = _ref2;
      const {
        onChange,
        options,
        name
      } = this.props;
      onChange && onChange(options[index].value, name, index);
    });
    (0, _defineProperty2.default)(this, "_isSelected", index => this.props.selectedIndex === index);
    (0, _defineProperty2.default)(this, "_menuNodeRef", node => {
      this._menuNode = node;
    });
    (0, _defineProperty2.default)(this, "_listRef", node => {
      this._list = node;
    });
    (0, _defineProperty2.default)(this, "_wrapperRef", node => {
      this._wrapper = node;
    });
    (0, _defineProperty2.default)(this, "_triggerRef", node => {
      this._triggerNode = node;
    });
    (0, _defineProperty2.default)(this, "_onCollapseMouseDown", e => {
      // prevent input from loosing the focus at mousedown phase (prevent blur event)
      // event order: mousedown => blur => mouseup => click
      e.preventDefault();
    });
    (0, _defineProperty2.default)(this, "_onCollapseMouseUp", e => {
      // if clicking/dragging on the scrollbar, not collapse the dropdown,
      // otherwise manually update the state and loose the focus of input at mouseup phase
      if (this._list._node !== e.target && e.target !== e.currentTarget) {
        this._triggerNode.blur();
        this.props.onClose();
      }
    });
    (0, _defineProperty2.default)(this, "_setFocus", label => {
      refListPointer[label].current.focus();
    });
    this.currentGroup = null;
    this.state = {
      above: false,
      menuStyle: {},
      scrolled: false,
      focusIndex: _props.selectedIndex
    };
    this.listId = this.props.triggerNodeId || uniqueId('__selectList');

    // Create a map for refs on all dropdown options
    this.optionsRef = {};
    _props.options.forEach(option => {
      this.optionsRef[option.label] = _react.default.createRef();
    });
    refListPointer = this.optionsRef;
  }
  componentDidMount() {
    const {
      wrapperClickListener,
      onClose
    } = this.props;
    document.addEventListener('scroll', this.scrollHandler, true);
    window.addEventListener('resize', onClose);
    wrapperClickListener && this._wrapper.addEventListener('click', wrapperClickListener);
  }
  componentWillReceiveProps(nextProps) {
    const {
      open: nextOpen,
      focusIndex: nextFocusIndex,
      selectedIndex,
      onClose: nextClose
    } = nextProps;
    const {
      open: curOpen,
      focusIndex: curFocusIndex,
      onClose
    } = this.props;
    if (curOpen && nextOpen && curFocusIndex !== nextFocusIndex) {
      this.setState({
        focusIndex: nextFocusIndex
      });
      this._list && this._list.scrollAround(nextFocusIndex);
    } else if (!curOpen && nextOpen) {
      this.setState({
        focusIndex: selectedIndex
      });
      this._list && this._hasScrolling() && this._list.scrollAround(selectedIndex);
    }
    if (onClose !== nextClose) {
      window.removeEventListener('resize', onClose);
      window.addEventListener('resize', nextClose);
    }
    this._computeMenuState(nextProps);
  }
  componentDidUpdate(prevProps) {
    const {
      focusIndex
    } = this.state;
    const {
      open,
      grouped
    } = this.props;
    // This is responsible for scrolling the list to the correct point, when the first item in a group is selected
    // Click the first item in a group in a grouped dropdown, and observe the list scrolls to show the group label first
    if (grouped && open && open !== prevProps.open && focusIndex >= 0) {
      // this._list.scrollTo(focusIndex);
      const currentItem = this._list._getItemNode(focusIndex);
      if (currentItem && currentItem.childElementCount > 1) {
        // if this is the first item in its group, scrollup to show the group name as well
        const groupLabel = currentItem.querySelector(`.${labelClassName}`);
        const groupLabelOffset = window.getComputedStyle(groupLabel).marginTop;
        this._list._node.scrollTop -= parseInt(groupLabelOffset, 10);
      }
    }
  }
  componentWillUnmount() {
    const {
      wrapperClickListener,
      onClose
    } = this.props;
    document.removeEventListener('scroll', this.scrollHandler, true);
    window.removeEventListener('resize', onClose);
    wrapperClickListener && this._wrapper.removeEventListener('click', wrapperClickListener);
  }
  _computeMenuState(props) {
    const {
      truncated
    } = props;
    const {
      _wrapper,
      _triggerNode
    } = this;
    const newState = {};
    const nb = _triggerNode ? _triggerNode.getBoundingClientRect() : _wrapper.getBoundingClientRect();
    const listHeight = this._getListHeight();
    const style = {
      minWidth: _triggerNode ? _triggerNode.offsetWidth : _wrapper.offsetWidth,
      maxWidth: truncated && _triggerNode ? _triggerNode.offsetWidth : window.innerWidth - nb.left
    };
    const nearestTransform = !IE11 && getTransformedParentElement(_wrapper);
    const targetHeight = nearestTransform ? nearestTransform.getBoundingClientRect().height : window.innerHeight;
    const availableRoomBottom = window.innerHeight - nb.top - nb.height;
    const availableRoomTop = nb.top;

    // open down if the list can fit opening down or if the list cannot fit opening up and there's more room at the bottom
    if (availableRoomBottom < listHeight && availableRoomTop > availableRoomBottom) {
      const specs = (0, _listDropdownHelperFunctions.default)(_triggerNode, _wrapper, 'top');
      style.bottom = targetHeight - specs.top - nb.height;
      style.borderBottom = 'none';
      style.left = specs.left;
      newState.above = true;
    } else {
      const specs = (0, _listDropdownHelperFunctions.default)(_triggerNode, _wrapper, 'bottom');
      style.top = specs.top;
      style.borderTop = 'none';
      style.left = specs.left;
      newState.above = false;
    }
    newState.menuStyle = style;
    this.setState(newState);
  }
  _getNumGroup() {
    const {
      options,
      grouped
    } = this.props;
    let numGroup = 0;
    if (grouped && options.length >= 1) {
      const groupHeader = [options[0].group];
      options.forEach(option => {
        if (option.group !== groupHeader[groupHeader.length - 1]) {
          groupHeader.push(option.group);
        }
      });
      numGroup = groupHeader.length;
    }
    return numGroup;
  }
  _getListHeight() {
    const {
      size,
      options,
      showAllList
    } = this.props;
    const optionHeight = cssSize(size === 'small' ? 4 : 5);
    const optionsTotalHeight = optionHeight * options.length;
    const groupHeaderHeight = cssSize(4) * this._getNumGroup();
    if (showAllList) {
      return groupHeaderHeight + optionsTotalHeight;
    }
    return Math.min(optionHeight * 5, groupHeaderHeight + optionsTotalHeight);
  }
  _hasScrolling() {
    const {
      size,
      options,
      showAllList
    } = this.props;
    const optionHeight = cssSize(size === 'small' ? 4 : 5);
    const optionsTotalHeight = optionHeight * options.length;
    const groupHeaderHeight = cssSize(4) * this._getNumGroup();
    const defaultHeight = optionHeight * 5;
    return !!(!showAllList && defaultHeight < groupHeaderHeight + optionsTotalHeight);
  }

  // update the min width of the menu based on the current width of the menu such that as the user
  // scrolls and new menu items are drawn, the menu will never become smaller and only grow in width
  // TODO we actually need to know when the list width changes. Use Measure to detect width changes.
  _optionId(index) {
    return `${this.listId}_${index}`;
  }
  render() {
    const {
      id,
      truncated,
      textDir,
      open,
      options,
      grouped,
      size,
      triggerNodeRenderer,
      className,
      customWidth,
      onKeyUp,
      onKeyDown,
      dropdownFooterRenderer,
      dropdownHeaderRenderer,
      style,
      ariaLabel,
      virtualized,
      ...others
    } = this.props;
    const {
      above,
      menuStyle,
      focusIndex,
      scrolled
    } = this.state;
    const selectionProps = {
      selectionMode: 'single',
      isSelected: this._isSelected,
      onSelectionChange: this._onSelectionChange
    };
    const wrapperProps = {
      ...sanitize(others, ListDropdown),
      id,
      className: `${dropdownClassName}__wrapper ${className}`,
      style: {
        width: customWidth
      },
      onKeyUp,
      onKeyDown,
      ref: this._wrapperRef,
      onClick: e => e.stopPropagation()
    };
    const collapseProps = {
      className: (0, _utils.classnames)(dropdownClassName, {
        truncated,
        above,
        grouped,
        [size]: size
      }),
      isOpened: !!open,
      style: {
        ...menuStyle,
        ...style
      },
      ref: this._menuNodeRef,
      autoUnmount: true,
      onMouseDown: this._onCollapseMouseDown,
      onMouseUp: this._onCollapseMouseUp,
      'aria-label': ariaLabel
    };
    const measureProps = {
      onResize: this._onMenuWidthChange
    };
    const listContainerProps = {
      style: {
        height: this._getListHeight()
      }
    };
    const listProps = {
      id: this.listId,
      tabIndex: -1,
      length: options.length,
      itemRenderer: this._menuItemRenderer,
      initialIndex: focusIndex,
      onClick: e => e.stopPropagation(),
      overflowX: IE11 ? 'hidden' : null,
      onActiveChange: this._onActiveChange,
      activeIndex: focusIndex,
      alwaysDisplayActive: true,
      ref: this._listRef,
      textDir,
      virtualized,
      ...selectionProps
    };
    const dropdownContent = /*#__PURE__*/_react.default.createElement(_collapse.default, collapseProps, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, dropdownHeaderRenderer && dropdownHeaderRenderer(), /*#__PURE__*/_react.default.createElement(_reactMeasure.default, measureProps, _ref3 => {
      let {
        measureRef
      } = _ref3;
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        ref: measureRef
      }, listContainerProps), /*#__PURE__*/_react.default.createElement(_list.default, listProps));
    }), dropdownFooterRenderer && dropdownFooterRenderer()));
    return /*#__PURE__*/_react.default.createElement("div", wrapperProps, triggerNodeRenderer(this._triggerRef), !scrolled && dropdownContent);
  }
}
exports["default"] = ListDropdown;
(0, _defineProperty2.default)(ListDropdown, "propTypes", {
  id: _propTypes.default.string,
  triggerNodeId: _propTypes.default.string,
  truncated: _propTypes.default.bool,
  menuStyle: _propTypes.default.bool,
  open: _propTypes.default.bool,
  customWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  size: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    group: _propTypes.default.any,
    value: _propTypes.default.any.isRequired,
    label: _propTypes.default.string.isRequired,
    icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
    onIconClick: _propTypes.default.func
  })).isRequired,
  grouped: _propTypes.default.bool,
  showAllList: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onScrollClose: _propTypes.default.func,
  name: _propTypes.default.string,
  selectedIndex: _propTypes.default.number,
  focusIndex: _propTypes.default.number,
  onActiveChange: _propTypes.default.func,
  wrapperClickListener: _propTypes.default.func,
  triggerNodeRenderer: _propTypes.default.func.isRequired,
  listItemContentRenderer: _propTypes.default.func,
  className: _propTypes.default.string,
  onKeyUp: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  dropdownHeaderRenderer: _propTypes.default.func,
  dropdownFooterRenderer: _propTypes.default.func,
  onClose: _propTypes.default.func,
  style: _propTypes.default.object,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  ariaLabel: _propTypes.default.string,
  virtualized: _propTypes.default.bool
});
(0, _defineProperty2.default)(ListDropdown, "defaultProps", {
  grouped: false,
  truncated: true,
  selectedIndex: -1,
  open: false,
  className: '',
  listItemContentRenderer: (props, thisProps) => {
    const {
      options,
      truncated,
      textDir
    } = thisProps;
    const {
      label,
      title
    } = options[props.index];
    return /*#__PURE__*/_react.default.createElement(_flexlayout.FlexItem, {
      shrink: true,
      grow: true,
      ref: refListPointer[label],
      basis: "auto",
      className: `${dropdownClassName}__menuItemInner`
    }, /*#__PURE__*/_react.default.createElement(_label.default, {
      ellipsis: truncated,
      label: label || '',
      textDir: textDir,
      truncatedTextExtraOptions: {
        title
      }
    }));
  }
});

/***/ }),

/***/ 67672:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _ListDropdown = _interopRequireDefault(__webpack_require__(10046));
exports["default"] = _ListDropdown.default;
exports.ListDropdown = _ListDropdown.default;

/***/ }),

/***/ 93757:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.__esModule = true;
exports["default"] = getSpecs;
exports.getResultSpecs = getResultSpecs;
exports.getValidPlacement = getValidPlacement;
var _utils = __webpack_require__(78815);
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  IE11,
  getTransformedParentElement
} = _utils.domUtils;

// Checks if all placements have been tried
function areRemainingPlacements(placementHistory) {
  if (placementHistory.indexOf('top') >= 0 && placementHistory.indexOf('bottom') >= 0 && placementHistory.indexOf('left') >= 0 && placementHistory.indexOf('right') >= 0) {
    return false;
  }
  return true;
}
function getStartingOffset(triggerRectOffset, nearestRectOffset, scroll, positionedElement) {
  return triggerRectOffset - nearestRectOffset - (positionedElement ? 0 : scroll);
}
const invalidSpecs = {
  top: 0,
  left: 0,
  placement: 'right',
  invalid: true
};

// Returns the actual result specs to use once placement is determined for sure
function getResultSpecs(placement, listDropdownTrigger, triggerRect, containerRect, scrollTop, scrollLeft, options) {
  let resultTop;
  let resultLeft;
  let arrowRect;
  if (options.arrow) arrowRect = options.arrow.getBoundingClientRect();
  const nearestPositionedElement = !IE11 && getTransformedParentElement(listDropdownTrigger);
  const nearestRect = (nearestPositionedElement || document.body).getBoundingClientRect();
  switch (placement) {
    case 'top':
      resultTop = getStartingOffset(triggerRect.top, nearestRect.top, scrollTop, nearestPositionedElement) - containerRect.height;
      resultLeft = getStartingOffset(triggerRect.left, nearestRect.left, scrollLeft, nearestPositionedElement) + triggerRect.width;
      resultLeft -= triggerRect.width;
      if (arrowRect) {
        resultTop -= arrowRect.height < arrowRect.width ? arrowRect.height : arrowRect.width;
      }
      if (typeof options.offset !== 'undefined') {
        resultTop -= options.offset;
      }
      break;
    case 'bottom':
      resultTop = getStartingOffset(triggerRect.top, nearestRect.top, scrollTop, nearestPositionedElement) + triggerRect.height;
      resultLeft = getStartingOffset(triggerRect.left, nearestRect.left, scrollLeft, nearestPositionedElement) + triggerRect.width;
      resultLeft -= triggerRect.width;
      if (arrowRect) {
        resultTop += arrowRect.height < arrowRect.width ? arrowRect.height : arrowRect.width;
      }
      if (typeof options.offset !== 'undefined') {
        resultTop += options.offset;
      }
      break;
    case 'left':
      resultTop = getStartingOffset(triggerRect.top, nearestRect.top, scrollTop, nearestPositionedElement);
      resultLeft = getStartingOffset(triggerRect.left, nearestRect.left, scrollLeft) - containerRect.width;
      if (arrowRect) {
        resultLeft -= arrowRect.height < arrowRect.width ? arrowRect.height : arrowRect.width;
      }
      if (typeof options.offset !== 'undefined') {
        resultLeft -= options.offset;
      }
      break;
    case 'right':
      resultTop = getStartingOffset(triggerRect.top, nearestRect.top, scrollTop, nearestPositionedElement);
      resultLeft = getStartingOffset(triggerRect.left, nearestRect.left, scrollLeft) + triggerRect.width;
      if (arrowRect) {
        resultLeft += arrowRect.height < arrowRect.width ? arrowRect.height : arrowRect.width;
      }
      if (typeof options.offset !== 'undefined') {
        resultLeft += options.offset;
      }
      break;
    default:
      return invalidSpecs;
  }
  return {
    top: Math.round(resultTop),
    left: Math.round(resultLeft),
    placement,
    invalid: false
  };
}
function getValidPlacement(startingTop, startingLeft, heightToCheck, widthToCheck, placementParam, triggerRect, containerRect, options, arrowRect) {
  let placement = placementParam;
  let placementIsValid = false;
  const placementHistory = [];
  let checkTop;
  let checkLeft;
  while (!placementIsValid) {
    checkTop = startingTop;
    checkLeft = startingLeft;
    if (!areRemainingPlacements(placementHistory)) {
      return false;
    }
    switch (placement) {
      case 'top':
        checkTop -= containerRect.height;
        if (arrowRect) checkTop -= arrowRect.height;
        if (typeof options.offset !== 'undefined') checkTop -= options.offset;
        checkLeft += triggerRect.width - containerRect.width;
        if (checkTop > 0 && checkLeft > 0) {
          placementIsValid = true;
        } else if (placementHistory.indexOf('bottom') < 0) {
          placement = 'bottom';
        } else {
          placement = 'right';
        }
        placementHistory.push('top');
        break;
      case 'bottom':
        checkTop += triggerRect.height;
        if (arrowRect) checkTop += arrowRect.height;
        if (typeof options.offset !== 'undefined') checkTop += options.offset;
        checkLeft += triggerRect.width - containerRect.width;
        if (heightToCheck > checkTop + containerRect.height && checkLeft > 0) {
          placementIsValid = true;
        } else if (placementHistory.indexOf('top') < 0) {
          placement = 'top';
        } else {
          placement = 'right';
        }
        placementHistory.push('bottom');
        break;
      case 'left':
        checkLeft -= containerRect.width;
        if (arrowRect) checkLeft -= arrowRect.width;
        if (typeof options.offset !== 'undefined') checkLeft -= options.offset;
        if (checkLeft > 0 && heightToCheck > checkTop + containerRect.height) {
          placementIsValid = true;
        } else if (placementHistory.indexOf('right') < 0) {
          placement = 'right';
        } else {
          placement = 'top';
        }
        placementHistory.push('left');
        break;
      case 'right':
        checkLeft += triggerRect.width;
        if (arrowRect) checkLeft += arrowRect.width;
        if (typeof options.offset !== 'undefined') checkLeft += options.offset;
        if (widthToCheck > checkLeft + containerRect.width && heightToCheck > checkTop + containerRect.height) {
          placementIsValid = true;
        } else if (placementHistory.indexOf('left') < 0) {
          placement = 'left';
        } else {
          placement = 'top';
        }
        placementHistory.push('right');
        break;
      default:
        return false;
    }
  }
  return placement;
}

// Determines the position for listDropdown, while finding a valid placement and checking if there is space to place the listDropdown
function getSpecs(listDropdownTrigger, listDropdownContainer, placement, options) {
  if (options === void 0) {
    options = {};
  }
  if (!listDropdownTrigger || !listDropdownContainer || listDropdownTrigger.getBoundingClientRect === undefined || listDropdownContainer.getBoundingClientRect === undefined) {
    return invalidSpecs;
  }
  const triggerRect = listDropdownTrigger.getBoundingClientRect();
  const containerRect = listDropdownContainer.getBoundingClientRect();
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const {
    body
  } = document;
  const html = document.documentElement;
  const pageHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.offsetHeight);
  const pageWidth = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.offsetWidth);
  let arrowRect;
  if (options.arrow) arrowRect = options.arrow.getBoundingClientRect();

  // Check if a valid placement that fits in the current window the page exists
  let validPlacement = getValidPlacement(triggerRect.top, triggerRect.left, window.innerHeight, window.innerWidth, placement, triggerRect, containerRect, options, arrowRect);
  // If no valid placement fits in the current window, check if there exists a valid placement on the page (i.e. will not be fully visible in the window, but will fit on the page)
  if (!validPlacement) {
    validPlacement = getValidPlacement(triggerRect.top + scrollTop, triggerRect.left + scrollLeft, pageHeight, pageWidth, placement, triggerRect, containerRect, options, arrowRect);

    // If no room on the page to fit, then return as invalid
    if (!validPlacement) return invalidSpecs;
  }
  return getResultSpecs(validPlacement, listDropdownTrigger, triggerRect, containerRect, scrollTop, scrollLeft, options);
}

/***/ }),

/***/ 83827:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-label{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;display:inline-block;margin:0;user-select:none;cursor:default}.ba-common-label.is-disabled{cursor:not-allowed}.ba-common-label.is-disabled .ba-common-truncatedText{cursor:inherit}.ba--highContrast .ba-common-label.is-disabled{cursor:not-allowed;text-decoration:line-through}.ba-common-label{transition:opacity .2s ease-in-out;color:#161616}.ba-common-label.is-disabled{color:#c6c6c6}", ""]);

// exports
exports.locals = {
	"labelClassName": "\"ba-common-label\""
};

/***/ }),

/***/ 61508:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-dropdown__wrapper{display:inline-block;position:relative;max-width:100%}.ba-common-dropdown{position:fixed;white-space:nowrap;text-align:left;overflow-x:hidden;overflow-y:auto;z-index:9001}.ba-common-dropdown.is-truncated{width:100%}.ba-common-dropdown__menuItem{height:40px}.ba-common-dropdown__menuItem.is-focus{outline-offset:-2px;margin:0}[dir=ltr].ba-common-dropdown__menuItem{text-align:left}[dir=rtl].ba-common-dropdown__menuItem{text-align:right}[dir=ltr] .ba-common-dropdown__menuItem,.ba-common-dropdown__menuItem{text-align:left}[dir=rtl] .ba-common-dropdown__menuItem{text-align:right}.ba-common-dropdown.is-grouped .ba-common-dropdown__groupLabel{margin-left:16px;margin-top:8px}.ba-common-dropdown.is-grouped .ba-common-dropdown__menuItemInner{padding-left:16px}.ba-common-dropdown .ba-common-list .ba-common-label{color:#343334;cursor:default}.ba-common-dropdown.is-small .ba-common-dropdown__menuItem{height:32px}.ba-common-dropdown{color:#eaeaea;background-color:#fff;font-size:.875rem}@media screen and (-ms-high-contrast: active){.ba-common-dropdown{border:1px solid #fff}}.ba-common-dropdown[aria-expanded=true]{box-shadow:0 2px 8px 0 rgba(0,0,0,.1)}.ba-common-dropdown[aria-expanded=true].is-above{box-shadow:0 -2px 8px 0 rgba(0,0,0,.1)}.ba-common-dropdown__menuItem{color:#343334;font-weight:400}.ba-common-dropdown__menuItem .ba-common-truncatedText__text{line-height:1.25rem}", ""]);

// exports
exports.locals = {
	"dropdownClassName": "\"ba-common-dropdown\""
};

/***/ }),

/***/ 75497:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83827);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Label_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 9034:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61508);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ListDropdown_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 9597:
/***/ ((module) => {

"use strict";
module.exports = require("react-measure");

/***/ }),

/***/ 48477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__48477__;

/***/ }),

/***/ 77765:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__77765__;

/***/ }),

/***/ 37394:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__37394__;

/***/ }),

/***/ 70309:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__70309__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(67672));
/******/ return __webpack_exports__;
/******/ }
]);
});